import React from "react";

const ViewFileButton = ({ text, icon, ...props }) => {
  return (
    <button
      className="common-view-file-button"
      {...props}
    >
      {icon && icon}
      <p className="common-view-file-button-text">{text}</p>
    </button>
  );
};

export default ViewFileButton;
